import mainCss from '../../../../../assets/css/main.module.css';
import { makeStyles, Paper, Typography, Theme, List, ListItem, ListItemText, ListItemIcon, ListItemSecondaryAction } from "@material-ui/core";
import EmpfehlungPoint from './EmpfehlungPoint';
import useRkCtxBo from '../../../../../consumer/rk/ctx-provider/useRkCtx';
import { getTextBeitrag } from '../../../../../consumer/form/dto/StvZahlungsweise';
import NumberUtil from '../../../../../app/util/NumberUtil';
import FormBo from '../FormBo';

import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import InfoBtn from '../../../../cmp/info/InfoBtn';
import EmpfehlungBlock from './EmpfehlungBlock';
import AppInitSingletonBo from '../../../../../consumer/init/AppInitSingletonBo';
import GtmInfoBtnId from '../../../../../gtm/types/GtmInfoBtnId';
import { Skeleton } from '@material-ui/lab';


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: 300,
        margin: 'auto'
    },

    paperElevation10: {
        border: 1,
        borderColor: '#fc992c',
        borderStyle: 'solid'

    },

    notSelected: {
        opacity: '60%'
    },

    // ***************************
    listItemIconRoot: {
        minWidth: 30
    },
    listIcon: {
        width: 20,
        //height: 'auto'
    },

    listItemSecondaryAction: {
        right: 0
    },
    listItem: {
        paddingLeft: 8,
        paddingTop: 2,
        paddingBottom: 2
    },

    listItemTextDisabled: {
        color: theme.palette.grey[500]
    }
}));

const Li: React.FC<{
    gtmId: GtmInfoBtnId,
    primary: React.ReactNode, secondary?: React.ReactNode,
    checked: boolean, infoTitel?: string, infoText?: string
}> = ({ gtmId, primary, secondary, checked, infoTitel, infoText }) => {
    const classes = useStyles();
    return (
        <ListItem className={classes.listItem}>
            <ListItemIcon className={classes.listItemIconRoot}>{checked
                ? <CheckIcon className={classes.listIcon} color='secondary' />
                : <ClearIcon className={`${classes.listIcon} ${classes.listItemTextDisabled}`} />}</ListItemIcon>

            <ListItemText disableTypography={true}
                primary={checked ? <Typography variant='caption'>{primary}</Typography> : <Typography variant='caption' className={classes.listItemTextDisabled}>{primary}</Typography>}
                secondary={secondary && <Typography variant='body2'>{secondary}</Typography>} />

            {checked && infoText &&
                <ListItemSecondaryAction className={classes.listItemSecondaryAction}>
                    <InfoBtn text={infoText} titel={infoTitel} gtmId={gtmId} />
                </ListItemSecondaryAction>
            }
        </ListItem>);
}

const LiMitSchutzbrief: React.FC<{ checked: boolean }> = ({ checked }) => {
    return <>

        <Li checked={checked} primary={<strong>Hunde-Betreuung und Haushaltshilfe im Notfall</strong>}
            infoTitel="Hunde-Betreuung und Haushaltshilfe im Notfall"
            infoText="Sollten Sie erkranken oder einen Unfall haben, helfen Ihnen diese Leistungen."
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_BETREUUNG}></Li>
        <Li checked={checked} primary={<strong>Digitaler Tierarzt</strong>}
            infoTitel="Digitaler Tierarzt"
            infoText="Sie können pro Jahr 3 digitale Sprechstunden bei einem Tierarzt in Anspruch nehmen."
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_DIGIT_TIERARZT}></Li>
        <Li checked={checked} primary={<strong>Notfalltransport zum Tierarzt</strong>}
            infoTitel="Notfalltransport zum Tierarzt"
            infoText="Im Notfall, z.B. bei Verdacht auf Giftköder, organisieren wir einen Transport zum Tierarzt bzw. zur Tierklinik."
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_NOTFALLTRANSPORT}></Li>
        <Li checked={checked} primary={<strong>Vermittlung zum Tierarzt</strong>}
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_VERMITTLUNG_TIERARZT}></Li>
        <Li checked={checked} primary={<strong>Vermittlung einer rechtlichen Beratung</strong>}
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_BERATUNG_VERMITTLUNG}></Li>
        <Li checked={checked} primary={<strong>Beratung zu Einreise und Impfpflichten</strong>}
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_BERATUNG_IMPFUNG}></Li>
        <Li checked={checked} primary={<strong>Einfache Abwicklung über Hotline</strong>}
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_HOTLINE}></Li>
        <Li checked={checked} primary={<strong>Leistungen ohne Wartezeit</strong>}
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_OHNE_WARTEZEIT}></Li>

    </>
}
const LiOhneSchutzbrief: React.FC = () => {
    return <>
        <Li checked={true} primary={<strong>Ausfalldeckung für Tierarztkosten</strong>} secondary="bis 1.500 Euro"
            infoTitel="Ausfalldeckung für Tierarztkosten"
            infoText="Wird Ihr Hund durch einen fremden Hund verletzt und der Halter besitzt keine Haftpflicht-Versicherung, erstatten wir die Tierarztkosten bis zur genannten Summe."
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_TIERARZTKOSTEN} />
        <Li checked={true} primary={<strong>Führen ohne Leine oder Maulkorb</strong>}
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_OHNE_LEINE} />

        <Li checked={true} primary={<strong>Rettungs- und Bergungskosten</strong>}
            secondary="bis 20.000 Euro"
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_BERGUNGSKOSTEN} />

        <Li checked={true} primary={<strong>Ansprüche des Tierhüters</strong>}
            infoTitel="Ansprüche des Tierhüters"
            infoText="Dazu zählen auch Familienangehörige."
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_ANSPRUECHE} />

        <Li checked={true} primary={<strong>Schäden an privat gemieteten Räumen</strong>}
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_SCHAEDEN_GEMIETETE_RAEUME} />

        <Li checked={true} primary={<strong>Schäden an Mobiliar in Hotels, Ferienhäuser oder -wohnungen</strong>}
            secondary="bis 20.000 Euro"
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_SCHAEDEN_SONSTIGE} />

        <Li checked={true} primary={<strong>Welpen mitversichert</strong>}
            infoTitel="Welpen mitversichert"
            infoText="Bis zu einem Alter von 12 Monaten sind Welpen automatisch mitversichert."
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_WELPEN}
        />
        <Li checked={true} primary={<strong>Versicherungsschutz gilt auch im Ausland</strong>}
            gtmId={GtmInfoBtnId.PRODUKT_DECKUNG_AUSLAND} />

    </>
}


type Param = {
    loading: boolean,
    mitSchutzbrief: boolean,
    active: boolean,
    btn: React.ReactElement,
    mobileVersion: boolean,
    /** Zeigt nur die Infos ohne Preise an. */
    infoOnly: boolean | false,
}

export const exportProduktMitSchutzbrief = (bo: FormBo) => bo.produktMitSchutzbrief;

const MAP_LAUFZEIT_TEXT = new Map<number, string>([[1, 'Vertragslaufzeit 12 Monate'], [3, 'Vertragslaufzeit 3 Jahre']]);
const MAP_LAUFZEIT_TEXT_INFO = new Map<number, string>([[1, '12 Monaten'], [3, '3 Jahren']]);

const Produkt: React.FC<Param> = ({
    mitSchutzbrief, active, btn, mobileVersion, loading, infoOnly }) => {

    const rkCtxBo = useRkCtxBo();
    const classes = useStyles();

    // Zahlungsweise
    const zahlungsweiseText = rkCtxBo.zahlungsweise ? getTextBeitrag(rkCtxBo.zahlungsweise) : "";

    // Beitrag
    const beitrag = mitSchutzbrief ? rkCtxBo.paketMitSchutzbrief?.bruttobeitragLautZw : rkCtxBo.paketOhneSchutzbrief?.bruttobeitragLautZw;
    const beitragText = beitrag ? NumberUtil.formatWaehrung(beitrag) : undefined;

    const rendEmpfehlungBlock = mitSchutzbrief && mobileVersion;
    const rendEmpfehlungPoint = mitSchutzbrief && !mobileVersion;

    const laufzeitText = MAP_LAUFZEIT_TEXT.get(AppInitSingletonBo.vertragLaufzeitJahre);
    const laufzeitTextInfo = MAP_LAUFZEIT_TEXT_INFO.get(AppInitSingletonBo.vertragLaufzeitJahre);

    return (
        <div className={classes.root} style={{ marginTop: rendEmpfehlungBlock ? 0 : 30 }}>
            <Paper elevation={active ? 10 : 0} classes={{ elevation10: classes.paperElevation10 }}>
                {rendEmpfehlungPoint && <EmpfehlungPoint />}
                {rendEmpfehlungBlock && <EmpfehlungBlock />}
                <div className={`${mainCss.productHeader} ${!active && classes.notSelected}`}
                    style={{
                        borderTopLeftRadius: mitSchutzbrief ? 0 : undefined,
                        borderTopRightRadius: mitSchutzbrief ? 0 : undefined
                    }}>
                    <div style={{ margin: 5, textAlign: 'center' }}>
                        <Typography variant='subtitle1' color='textSecondary'>HUNDE-HAFTPFLICHT+</Typography>
                        <Typography variant='subtitle2' color='textSecondary'>{mitSchutzbrief ? 'MIT' : 'OHNE'} SCHUTZBRIEF</Typography>
                    </div>
                </div>

                {!infoOnly && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline', margin: 10, marginBottom: 0 }}>
                    {beitragText
                        ? <Typography color='textPrimary' variant='body1' style={{ transition: 'all, 1s', opacity: loading ? .1 : 1, fontSize: 32 }}>{beitragText}</Typography>
                        : <> <Skeleton variant="rect" width={80} height={40} style={{ marginRight: 10 }} /><Skeleton variant="rect" width={80} height={20} /></>}
                    <Typography color='textPrimary' variant='h6' style={{ transition: 'all, 1s', opacity: loading ? .1 : 1, marginLeft: 10 }}>{zahlungsweiseText}</Typography>
                </div>
                }
                {/* 
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography color='textPrimary' variant='body2'>{laufzeitText}</Typography>
                    <InfoBtn text={`Ihr Vertrag hat eine Laufzeit von ${laufzeitTextInfo} und verlängert sich automatisch um ein weiteres Jahr, sofern er nicht spätestens drei Monate vor dem Ablauf der jeweiligen Vertragslaufzeit gekündigt wird.`} titel="Laufzeit" />
                </div>
                */}
                <div style={{ marginLeft: 10, marginRight: 10 }}>
                    <List>
                        <ListItem className={classes.listItem}>
                            <ListItemIcon className={classes.listItemIconRoot}></ListItemIcon>
                            <ListItemText disableTypography={true}
                                primary={<Typography variant='body2' style={{ textAlign: 'center' }}>{laufzeitText}</Typography>} />

                            <ListItemSecondaryAction className={classes.listItemSecondaryAction}>
                                <InfoBtn text={`Ihr Vertrag hat eine Laufzeit von ${laufzeitTextInfo} und verlängert sich automatisch um ein weiteres Jahr, sofern er nicht spätestens drei Monate vor dem Ablauf der jeweiligen Vertragslaufzeit gekündigt wird.`}
                                    titel="Vertragslaufzeit" gtmId={GtmInfoBtnId.VERTRAGSLAUFZEIT} />
                            </ListItemSecondaryAction>
                        </ListItem>
                    </List>
                </div>
                <div style={{ marginLeft: 10, marginRight: 10, marginBottom: 10 }}>
                    <List>
                        <LiOhneSchutzbrief />
                        <LiMitSchutzbrief checked={mitSchutzbrief} />
                    </List>
                </div>

                {!infoOnly && <div style={{ padding: 10 }}>
                    {btn}
                </div>
                }
            </Paper >
        </div >)
}

export default Produkt;